import { logger } from "cayo.ui";
import { sleep } from "@cayo/shared/utils/sleep";

type StateResponse = { status: string };

export class UrlPollingManager {
  private urls: Map<string, any>;
  private pollingTimeout: number;
  private isRunning: boolean = false;
  private isPolling: boolean = false;
  private shouldRemove: (url: string, data: any, result: StateResponse | null) => boolean;
  private log = logger;
  constructor(
    urls: [string, any][], // Accept an array of key-value pairs
    pollingTimeout: number,
    shouldRemove: (url: string, data: any, result: StateResponse | null) => boolean
  ) {
    this.urls = new Map(urls);
    this.pollingTimeout = pollingTimeout;
    this.shouldRemove = shouldRemove;
  }

  public addUrl(url: string, data: any) {
    this.urls.set(url, data);
    if (this.isRunning && !this.isPolling) {
      this.poll();
    }
  }

  private async fetchState(url: string): Promise<StateResponse | null> {
    try {
      const response = await fetch(url);
      if (!response.ok) {
        return null;
      }
      return await response.json();
    } catch {
      return null;
    }
  }

  private async poll() {
    this.isPolling = true;

    try {
      while (this.isRunning && this.urls.size > 0) {
        const iterator = this.urls.keys();
        const url = iterator.next().value;
        if (!url) {
          break;
        }

        const response = await this.fetchState(url);
        const data = this.urls.get(url);
        if (
          !response || // TODO: more clever error handling ?
          this.shouldRemove(url, data, response)
        ) {
          this.urls.delete(url);
        }

        await sleep(this.pollingTimeout);
      }
    } catch (e) {
      this.log.error("Error in polling", e);
    } finally {
      this.isPolling = false;
    }
  }

  public start() {
    this.isRunning = true;
    if (!this.isPolling) {
      this.poll();
    }
  }

  public stop() {
    this.isRunning = false;
  }
}
